const c = {
  name: "Partner",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M0,3c0-1.7,1.3-3,3-3c1.7,0,3,1.3,3,3c0,1.3-0.8,2.4-2,2.8V12h3c2.2,0,4,1.8,4,4c0,1.2-0.5,2.3-1.4,3
			c0.8,0.7,1.4,1.8,1.4,3s-0.5,2.3-1.4,3c0.8,0.7,1.4,1.8,1.4,3s-0.5,2.3-1.4,3c0.8,0.7,1.4,1.8,1.4,3c0,1-0.3,1.9-0.9,2.6
			c0.1,0.3,0.3,0.6,0.5,0.9c0.4,0.4,0.9,0.6,1.4,0.6c1.1,0,2-0.9,2-2v0v-9h2l0,9l0,0c0,1.1,0.9,2,2,2c1.1,0,2-0.9,2-2v-9h2v9
			c0,1.1,0.9,2,2,2c1.1,0,2-0.9,2-2V19h-8c-2.2,0-4-1.8-4-4v-1c0-1.1,0.9-2,2-2h10V5.8c-0.9-0.3-1.5-1-1.8-1.8h-6.3
			c-0.4,1.2-1.5,2-2.8,2c-1.7,0-3-1.3-3-3c0-1.7,1.3-3,3-3c1.3,0,2.4,0.8,2.8,2h6.3c0.4-1.2,1.5-2,2.8-2c1.7,0,3,1.3,3,3
			c0,1.3-0.8,2.4-2,2.8V12h6.2c0.4-1.2,1.5-2,2.8-2c1.7,0,3,1.3,3,3c0,1.7-1.3,3-3,3c-1.3,0-2.4-0.8-2.8-2H16v1c0,1.1,0.9,2,2,2h10
			v19h6.2c0.3-0.9,1-1.5,1.8-1.8v-6.3c-1.2-0.4-2-1.5-2-2.8c0-1.7,1.3-3,3-3c1.7,0,3,1.3,3,3c0,1.3-0.8,2.4-2,2.8v6.3
			c1.2,0.4,2,1.5,2,2.8c0,1.7-1.3,3-3,3c-1.3,0-2.4-0.8-2.8-2h-6.7c-0.7,1.2-2,2-3.5,2c-1.2,0-2.3-0.5-3-1.4c-0.7,0.8-1.8,1.4-3,1.4
			c-1.2,0-2.3-0.5-3-1.4c-0.7,0.8-1.8,1.4-3,1.4c-1.1,0-2.1-0.5-2.8-1.2c-0.3-0.3-0.6-0.7-0.8-1.1C8,37.9,7.5,38,7,38H4
			c-2.2,0-4-1.8-4-4c0-1.2,0.5-2.3,1.4-3C0.5,30.3,0,29.2,0,28s0.5-2.3,1.4-3C0.5,24.3,0,23.2,0,22s0.5-2.3,1.4-3
			C0.5,18.3,0,17.2,0,16c0-1.5,0.8-2.8,2-3.5V5.8C0.8,5.4,0,4.3,0,3z M3,2C2.4,2,2,2.4,2,3c0,0.6,0.4,1,1,1c0.6,0,1-0.4,1-1
			C4,2.4,3.6,2,3,2z M15,2c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1s1-0.4,1-1C16,2.4,15.6,2,15,2z M26,3c0,0.6,0.4,1,1,1c0.6,0,1-0.4,1-1
			c0-0.6-0.4-1-1-1C26.4,2,26,2.4,26,3z M37,12c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1s1-0.4,1-1C38,12.4,37.6,12,37,12z M36,25
			c0,0.6,0.4,1,1,1s1-0.4,1-1s-0.4-1-1-1S36,24.4,36,25z M37,36c-0.6,0-1,0.4-1,1s0.4,1,1,1s1-0.4,1-1S37.6,36,37,36z M4,14
			c-1.1,0-2,0.9-2,2c0,1.1,0.9,2,2,2h3c1.1,0,2-0.9,2-2c0-1.1-0.9-2-2-2H4z M4,30h3c1.1,0,2-0.9,2-2c0-1.1-0.9-2-2-2H4
			c-1.1,0-2,0.9-2,2C2,29.1,2.9,30,4,30z M4,32c-1.1,0-2,0.9-2,2c0,1.1,0.9,2,2,2h3c1.1,0,2-0.9,2-2c0-1.1-0.9-2-2-2H4z M7,24
			c1.1,0,2-0.9,2-2c0-1.1-0.9-2-2-2H4c-1.1,0-2,0.9-2,2c0,1.1,0.9,2,2,2H7z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Partner
};
